import { useEffect } from 'react';

import type { DesignTokens } from '@/handshake/protocol.js';
import { applyDesignTokens, clearDesignTokens } from '@/lib/design-tokens.js';

/** Applies the host's live design tokens to `:root` so the iframe matches its surroundings. */
export function TenantTheme({ tokens }: { tokens: DesignTokens | null }) {
  useEffect(() => {
    if (!tokens) return;
    applyDesignTokens(tokens);
    return () => clearDesignTokens();
  }, [tokens]);

  return null;
}
